import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
// import config from 'config';
import Cookies from 'js-cookie';
import config from '../config';
import Initial from '../helpers/Initial';
// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={config.defaultPath} className='main-logo'>
        {process.env.REACT_APP_SERVER && process.env.REACT_APP_SERVER == "demo" ?  <img src={Initial?.branding?.logo} alt='Main Logo'/> : <img src={Initial?.branding?.logo} alt="Logo"/>}
    </ButtonBase>
);

export default LogoSection;